var t={wrap:"styles_wrap__n2gxL",title:"styles_title__ScyQz"};export{t as default};
